
















































































// 定数
import {
  PartsListHeaders,
  PartsListHeadersFJapan,
  DetailsAdditionalInputListHeaders,
  EstimateInputDataColumns,
  EstimateListDisplayButtonItems,
  EstimateTableSearchLargeItemData,
  EstimateTableTaxClassificationSearchSmallItemData,
  EstimateTableTaxClassificationSearchLargeItemData,
  EstimateTableSearchSmallItemData,
  EstimateCommodityMasterDatas,
  EstimateDatailAddInputBaseFormat,
  EstimateMasterDatas,
  EstimateDatailBaseFormat,
  EstimateListDisplayInputFormatItemsPartsList,
  EstimateListDisplayInputFormatItemsDetailAddList,
  EstimateListDisplayInputFormatItemsEstimateDetailList,
  ExceptionHeaderItem,
  authorityValidMessage,
  authorityInvalidMessage,
  registerFinishText,
  ZeroVisibleCheckBoxsData,
  EstimateMonthlyLeaseFeeWording,
  TemplateWarningMessage,
  EstimateFractionRoundWording
} from '@/constants/estimate/estimate';

import hexabaseState from '@/store/hexabase';
import userState from '@/store/user';
// Component
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/modules/Header.vue';
import SideMenu from '@/components/common/modules/SideMenu.vue';
import PageInfoBar from '@/components/common/modules/PageInfoBar.vue';
import TransitionDialog from '@/components/common/modules/TransitionDialog.vue';
import ExecAction from '@/components/common/modules/ExecAction.vue';

import HeaderPanel from '@/components/common/modules/HeaderPanel.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';
import TabPanel from '@/components/common/modules/TabPanel.vue';
import Dialog from '@/components/common/modules/Dialog.vue';

import StatusBox from '@/components/common/modules/StatusBox.vue';

// Model
import Estimate from '@/models/estimateModel';
import CalculationModel from '@/models/calculationModel';

import { CheckBoxProps } from '@/constants/form/types';
import { DSNames } from '@/constants/dataStore';
import appState from '@/store/app';

// Form
import {
  estimateInfomationHeader,
  estimateSubjectNames,
  estimateOAInformations,
  estimateGeneralInformations,
  estimateInformationSummary
} from '@/constants/form/estimateForm';
import { ApiData, GetInputFieldsActons, FieldChildrenProp } from '@/services/hexabase/types';

/** ワーク用 インターフェース ToDo: 外出しを検討する！ */
interface PartsListDataFormat {
  Status: string;
  classification_id: string;
  commodity_id: string;
  created_at: any;
  created_by: any;
  d_id: string;
  display_material_id: string;
  i_id: string;
  id: any;
  item: string;
  item_code: string;
  model_number: string;
  p_id: string;
  parts_supplier_id: string;
  remarks: string;
  rev_no: number;
  standard_unit_price: number;
  unit_lower_limit?: number;
  unit_upper_limit?: number;
  status_id: string;
  title: string;
  transfer_unit_price: number;
  type_id: string;
  unread: any;
  updated_at: any;
  updated_by: any;
  No: number;
  quantity: number;
  quantity_lower_limit?: number;
  quantity_upper_limit?: number;
  reference_transfer_unit_price: number;
  sale_price: number;
  transfer_amount_price: number;
  operating_income: number;
  profit_rate: any;
  edit_price_flag?: string | boolean;
  edit_material_flag?: string | boolean;
  buttonDisabled?: string | boolean;
}

@Component({
  components: {
    Header,
    SideMenu,
    PageInfoBar,
    TransitionDialog,
    ExecAction,
    TabPanel,
    HeaderPanel,
    AutoCreateForm,
    StatusBox,
    Dialog
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class EstimateRegister extends Vue {
  private self: this = this;

  private estimate = new Estimate();
  // 計算関係のモデル
  private calculationModel = new CalculationModel();
  // 本画面で使用する小数点を四捨五入する際のデフォルト値
  private defaultRoundingType = { calculationType: 'decimalRound', digit: 1 };
  // 案件基本情報共通ヘッダー
  private estimateHeaderData = { cols: {}, datas: {} as { [k: string]: any } };
  // 見積件名、見積版名
  private estimateSubjectData = { cols: {}, datas: {} as { [k: string]: any } };
  // 見積情報タブ内見積情報
  private estimateInformationPanel = { cols: {}, datas: {} as { [k: string]: any } };
  private estimateInformationsData = {};
  // 見積情報タブ内見積情報
  private creditEstimateInformationPanel = { cols: {}, datas: {} as { [k: string]: any } };
  private fixedEstimateInformationPanel = { cols: {}, datas: {} as { [k: string]: any } };

  // 見積集計情報
  private estimateInformationSummary = { cols: {}, datas: {} as { [k: string]: any } };
  // dbID格納プロパティ
  private matterDsId = '';
  private matterServiceDsId = '';
  private estimateDsId = '';
  // 登録先となる案件サービス(OA、汎用、F-Japan)のi_id
  private projectServiceItemId = '';
  // APIレスポンス
  private matterInformatioResult: ApiData = [];
  // 発注の初期ステータス
  private displayStatus = '';
  // アイテム登録後ダイアログ
  private dialogStatus = false;
  private isLoading = false;
  private registerText = this.estimate.deepCopy(registerFinishText);
  private buttons: Array<{ [k: string]: string | number }> = [
    {
      id: 1,
      color: 'primary',
      type: 'routing',
      name: 'toEdit',
      value: '詳細画面へ',
      route: '/estimate/edit/:datastoreId/:id'
    }
  ];
  private registAuthority = false;
  private guideMessage = '';

  // 案件詳細から受け渡された案件情報のアイテムID
  private passedItemId = this.$route.params.id;

  private serviceTypeItemId = '';
  private serviceType = '';
  private screenStructureType = '';
  private showDetailAddListFlag = true;
  private estimateId = '';

  // マスタデータ関連格納プロパティ
  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  // マスター参照系の変数
  // 商材
  private masterCommoditySelectData: any = [];
  // 明細追加入力マスタ
  private mastermEstimateDetailAddInputSelectData: any = [];
  private masterEstimateDetailAddInputSelectItem = {
    title: '明細追加入力マスタ',
    column: EstimateMasterDatas.DatailAddInputColumns,
    data: this.mastermEstimateDetailAddInputSelectData,
    searchItemData: {
      // 区分、種別、品名
      searchLargeItemData: EstimateTableSearchLargeItemData,
      searchSmallItemData: EstimateTableSearchSmallItemData,
      freeFormatLabelName: '品名',
      freeFormatLabelDisplayId: 'item',
      labelName: ['区分', '種類']
    }
  };
  // 見積明細マスタ
  private mastermEstimateDetailSelectData: any = [];
  // 料率マスタ
  private mastermEstimateRateData: any = [];
  // 課税区分マスタ
  private masterTaxData: any = [];
  private masterTaxSelectItem = {
    title: '課税区分マスタ',
    column: EstimateMasterDatas.masterTaxColumns,
    data: this.masterTaxData,
    searchItemData: {
      // 区分、種別、品名
      searchLargeItemData: EstimateTableTaxClassificationSearchLargeItemData,
      searchSmallItemData: EstimateTableTaxClassificationSearchSmallItemData,
      freeFormatLabelName: '',
      freeFormatLabelDisplayId: '',
      labelName: ['名称', '税率']
    }
  };
  // 構成表、見積表タブ内一覧
  private partsListColumn: Array<{ [k: string]: string | number }> = [];
  // 表示用構成表
  private partsListViewData: any = [];
  // ベースとなる構成表
  private partsListBaseData: any = [];
  private detailAddListColumn: Array<{ [k: string]: string | number }> = [];
  private detailAddListData: any = [];
  private detailListColumn: Array<{ [k: string]: string | number }> = [];
  private detailListData: any = [];
  // 商材マスタ参照選択のバリデーションルール
  private commodityRules = '';
  // TabPanelのオプションにEagerを付けて、タブの子要素をマウント時にレンダリングさせる
  private isEager = true;
  private registFieldType: any = {};
  private registPartsListFieldType: any = {};
  private registDetailAddListCFieldType: any = {};
  private registEstimateDetailListFieldType: any = {};

  // 「数量がゼロの行を非表示」チェックボックスデータ
  private checkBoxsData: Array<CheckBoxProps> = ZeroVisibleCheckBoxsData;
  // 「数量がゼロの行を非表示」チェックボックス状態
  private checkBoxsStatus = false;

  private mtempleteSelectDataOption: Array<{
    text: string;
    value: string | number;
  }> = [];
  private mtempleteSelectData = {
    label: '',
    name: 'select',
    disabled: false,
    dense: true,
    options: this.mtempleteSelectDataOption
  };
  private mtempleteSelectValue: any = {};

  private estimateTabData: any = [
    {
      title: '構成表',
      configurationTableData: {
        masterSelectDataCommodity: {
          columns: EstimateCommodityMasterDatas.Columns,
          body: this.masterCommoditySelectData,
          dialogTitle: '商材マスタ',
          outPutData: [
            { label: '商材', name: 'commodity', isReadOnly: true, isDisabled: true },
            { label: '商材仕入先', name: 'supplier_id', isReadOnly: true, isDisabled: true }
          ],
          searchLargeItemData: {
            findItemName: 'commodity',
            setItemValue: 'commodity',
            setItemText: 'commodity'
          },
          searchSmallItemData: {
            findItemName: 'supplier_id',
            setItemValue: 'supplier_id',
            setItemText: 'supplier_id'
          },
          title: '商材マスタ',
          labelName: ['商材', '商材仕入先'],
          rules: this.commodityRules,
          isBtnVisible: true,
          isShow: true,
          isLoadingFlag: false,
          isParentDialogControlFlag: true
        },
        vmSelectDataTemplete: {
          selectData: this.mtempleteSelectData,
          selectValue: this.mtempleteSelectValue,
          isDisabled: true,
          isBtnVisible: true,
          isShow: true,
          isLoadingFlag: false,
          isParentDialogControlFlag: true,
          displayInfomation: ''
        },
        partsList: {
          listName: '構成明細',
          checkBoxsData: this.checkBoxsData,
          isAddItemButtonFlag: false,
          tableParameters: {
            buttonItems: EstimateListDisplayButtonItems,
            inputItems: EstimateListDisplayInputFormatItemsPartsList,
            columns: this.partsListColumn,
            body: this.partsListViewData,
            tableText: '商材が選択されていません'
          },
          subHeadersScrollWidthData: 0,
          masterSelectItem: this.masterTaxSelectItem
        },
        detailAddList: {
          listName: '明細追加入力一覧',
          isAddItemButtonFlag: true,
          isShow: false,
          tableParameters: {
            buttonItems: EstimateListDisplayButtonItems,
            inputItems: EstimateListDisplayInputFormatItemsDetailAddList,
            columns: this.detailAddListColumn,
            body: this.detailAddListData,
            tableText: '項目が選択されていません'
          },
          masterSelectItem: {
            selectButtonIndex: this.masterEstimateDetailAddInputSelectItem,
            taxClassificationButton: this.masterTaxSelectItem
          }
        }
      },
      component: 'ConfigurationTable'
    },
    {
      title: '見積情報',
      // estimateInformationData: {
      //   estimateRateTabData: [
      //     {
      //       title: '見積作成（社内料率）',
      //       configurationTableData: {
      //         estimateDetailInformation: {
      //           estimateInformationPanel: this.estimateInformationPanel
      //         }
      //       },
      //       component: 'RateTable'
      //     },
      //     {
      //       title: '見積作成（与信料率）',
      //       configurationTableData: {
      //         estimateDetailInformation: {
      //           estimateInformationPanel: this.creditEstimateInformationPanel
      //         },
      //         disabled: true
      //       },
      //       component: 'RateTable'
      //     },
      //     {
      //       title: '見積作成（確定料率）',
      //       configurationTableData: {
      //         estimateDetailInformation: {
      //           estimateInformationPanel: this.fixedEstimateInformationPanel
      //         },
      //         disabled: true
      //       },
      //       component: 'RateTable'
      //     }
      //   ],
      //   estimateDetailInformation: {
      //     estimateInformationPanel: this.estimateInformationPanel
      //   },
      //   estimateDetailList: {
      //     listName: '見積表',
      //     isAddItemButtonFlag: true,
      //     tableParameters: {
      //       buttonItems: EstimateListDisplayButtonItems,
      //       inputItems: EstimateListDisplayInputFormatItemsEstimateDetailList,
      //       columns: this.detailListColumn,
      //       body: this.detailListData,
      //       tableText: '項目が選択されていません'
      //     },
      //     masterSelectItem: {
      //       title: '見積明細マスタ',
      //       column: [],
      //       data: this.mastermEstimateDetailSelectData,
      //       searchItemData: {
      //         // 区分、種別、項目
      //         searchLargeItemData: EstimateTableSearchLargeItemData,
      //         searchSmallItemData: EstimateTableSearchSmallItemData,
      //         freeFormatLabelName: '項目',
      //         freeFormatLabelDisplayId: 'item',
      //         labelName: ['区分', '種類']
      //       }
      //     }
      //   },
      //   estimateDetailSummary: {
      //     estimateDetailSummary: []
      //   },
      //   createTaxSummary: {
      //     taxSummaryColumns: [],
      //     taxData: []
      //   }
      // },
      // component: 'EstimateInformation',
      disabled: true
    }
  ];

  // 登録用情報格納プロパティ
  private registData: any = {
    'use_display_id': true,
    'ensure_transaction': true,
    'action_id': 'temporarily_save',
    'item': {},
    'related_ds_items': {}
  };

  // 各一覧用登録データ
  private registMaterialItemData: any = [];
  private registDatailAddInputItemData: any = [];
  private registEstimateDetailItemData: any = [];

  private projectId = hexabaseState.applicationId;

  private selectOptions: any = {};

  private insertActionId = '';
  private exceptionHeaderItem = ExceptionHeaderItem;

  // 月額リース料に端数が発生した場合、登録時にワーニング表示する内容
  private isExecDialog = false;
  private execDialogMessage = EstimateMonthlyLeaseFeeWording.execDialog.message;
  private execDialogTitle = EstimateMonthlyLeaseFeeWording.execDialog.title;
  private fractionValue = 0;
  private execActionType = '';

  //  税率毎サマリパネル
  private taxSummaryColumns: Array<{ [k: string]: string | number }> = [
    { value: 'name', text: '課税区分', order: 0, width: '15%' },
    { value: 'tax_rate', text: '税率（％）', order: 1, width: '15%' },
    { value: 'amount', text: '金額', order: 2, width: '15%' },
    { value: 'tax', text: '税額', order: 3, width: '15%' },
    { value: 'tax_included_amount', text: '合計', order: 4, width: '15%' }
  ];
  private taxData: Array<{ [k: string]: string | number }> = [];
  private defaultTaxData: any = {}

  // アラートダイアログに表示する内容
  private isAlertDialog = false;
  private alertDialogMessage = '';
  private alertDialogTitle = '';

  async created() {
    try {
      // ローディングをセット
      this.$store.commit('hexabase/setIsLoading', true);

      // 案件基本情報の取得準備
      this.matterDsId = hexabaseState.datastoreIds['案件基本情報'];
      // 取得した案件基本情報のi_idから関連アイテムを含めて、取得する
      // 案件基本情報(0)
      // 各マスタ取得(1)
      // 構成表、明細追加入力マスタ、明細追加入力、見積明細マスタ、見積明細(2～6)
      const [
        matterInformatioResult
      ] = await Promise.all([
        this.estimate.getLinkedItems(
          hexabaseState.applicationId,
          this.matterDsId,
          this.passedItemId,
          'use_display_id=true'
        ),
        this.estimate.getRegisterMasterData(),
        this.estimate
          .getFieldsData(this.projectId, hexabaseState.datastoreIds['明細追加入力マスタ'])
          .then(response => {
            this.setHeaderListColumn(
              response,
              EstimateMasterDatas.DatailAddInputColumns,
              this.estimateTabData[0].configurationTableData.detailAddList.masterSelectItem,
              'column',
              this.exceptionHeaderItem
            );
          }),
        this.estimate
          .getFieldsData(this.projectId, hexabaseState.datastoreIds['明細追加入力'])
          .then(response => {
            this.setHeaderListColumn(
              response,
              DetailsAdditionalInputListHeaders,
              this.estimateTabData[0].configurationTableData.detailAddList.tableParameters,
              'columns',
              this.exceptionHeaderItem
            );
          }),
        this.estimate.getNewActionList(hexabaseState.datastoreIds['構成表']).then(response => {
          const actionItem = this.newItemActionExtraction(response, 'temporarily_save');
          this.estimate
            .getFieldsByActionId(hexabaseState.datastoreIds['構成表'], actionItem!.action_id)
            .then(response => {
              this.setRegistFieldType(response, this.registPartsListFieldType);
              // 構成表一覧の入力項目フォーマット
              const partsListInputFormat = this.estimateTabData[0].configurationTableData.partsList
                .tableParameters.inputItems;
              this.listInputFieldRuleCheck(partsListInputFormat, response);
            });
        }),
        this.estimate
          .getNewActionList(hexabaseState.datastoreIds['明細追加入力'])
          .then(response => {
            const actionItem = this.newItemActionExtraction(response, 'temporarily_save');
            this.estimate
              .getFieldsByActionId(
                hexabaseState.datastoreIds['明細追加入力'],
                actionItem!.action_id
              )
              .then(response => {
                this.setRegistFieldType(response, this.registDetailAddListCFieldType);
                // 明細追加入力一覧の入力項目フォーマット
                const detailAddListInputFormat = this.estimateTabData[0].configurationTableData
                  .detailAddList.tableParameters.inputItems;
                this.listInputFieldRuleCheck(detailAddListInputFormat, response);
              });
          })
      ]);
      this.matterInformatioResult = matterInformatioResult;

      // 案件IDを登録情報に設定
      this.registData.item['project_id'] = this.matterInformatioResult.field_values['project_id'][
        'value'
      ];
      // サービス種別で使用する見積基本情報を変更
      this.serviceTypeItemId = this.matterInformatioResult.field_values['service_type_id']['value'][
        'lookup_item'
      ]['i_id'];
      this.serviceType = this.matterInformatioResult.field_values['service_type_id']['value'][
        'lookup_item'
      ]['service_type'];
      this.screenStructureType = this.matterInformatioResult.field_values['service_type_id'][
        'value'
      ]['lookup_item']['screen_structure_type'];
      switch (this.screenStructureType) {
        case '1': {
          // OAリース
          this.matterServiceDsId = hexabaseState.datastoreIds['案件サービス別OA'];
          this.estimateDsId = hexabaseState.datastoreIds['見積基本情報OA'];
          this.projectServiceItemId = this.matterInformatioResult.linked_items.t_project_service_OA.items[0].i_id;
          break;
        }
        case '99': {
          // 汎用
          this.matterServiceDsId = hexabaseState.datastoreIds['案件サービス別汎用'];
          this.estimateDsId = hexabaseState.datastoreIds['見積基本情報汎用'];
          this.projectServiceItemId = this.matterInformatioResult.linked_items.t_project_service_general.items[0].i_id;
          break;
        }
        case '2': {
          // F-Japan
          this.matterServiceDsId = hexabaseState.datastoreIds[DSNames[this.screenStructureType].PROJECT_SERVICE];
          this.estimateDsId = hexabaseState.datastoreIds[DSNames[this.screenStructureType].ESTIMATE_BASIC_INFOMATION];
          this.projectServiceItemId = this.matterInformatioResult.linked_items.t_project_service_fjapan.items[0].i_id;
          break;
        }
        default: {
          break;
        }
      }
      if (this.screenStructureType === '2') {
        // F-Japanの場合、「数量がゼロの行を非表示」のチェックボックスを隠す
        this.checkBoxsData.splice(0, 1);
      } else {
        // 数量がゼロの行を非表示のチェックボックス初期値と状態を(false)に設定
        this.checkBoxsData[0].default = false;
        this.checkBoxsStatus = false;
      }

      // 明細追加入力表示/非表示フラグ値を取得してセット
      // （文字列となっているので変換）
      this.showDetailAddListFlag = JSON.parse(
        this.matterInformatioResult.linked_items.m_service_type.items[0].show_detail_add_list_flag.toLowerCase()
      );
      this.estimateTabData[0].configurationTableData.detailAddList.isShow = this.showDetailAddListFlag;

      // 共通ヘッダー情報の作成
      this.estimateHeaderData = this.getHeaderFields(estimateInfomationHeader);
      const headerData = {
        // 顧客番号、顧客名、案件名、見積番号、サービス種別、支払情報、見積作成者
        0: this.matterInformatioResult.field_values['customer_id']['value']['lookup_item'][
          'customer_id'
        ],
        1: this.matterInformatioResult.field_values['customer_id']['value']['lookup_item'][
          'customer_name'
        ],
        2: this.matterInformatioResult.field_values['project_name']['value'],
        3: '', // 見積番号(新規作成なので番号なし)
        4: this.serviceType,
        5:
          this.matterInformatioResult.linked_items.m_payment_information !== null
            ? this.matterInformatioResult.linked_items.m_payment_information.items[0]
                .payment_information
            : '',
        6: userState.userName
      };
      this.getHeaderData(headerData, this.estimateHeaderData);
      // 見積件名、見積版名の設定
      this.estimateSubjectData = this.getHeaderFields(estimateSubjectNames);
      const subjectData = {
        // 見積件名、見積版名(新規作成なので入力値はブランク)
        0: '',
        1: ''
      };
      this.getHeaderData(subjectData, this.estimateSubjectData);

      // マスターデータを取得しグローバル変数に格納
      this.masterData = this.estimate.getMaster();
      // 課税区分に登録がない場合のデフォルト値
      this.defaultTaxData = this.masterData['m_tax'].body.find(
        (v: any) => v.current_tax_flag === 1
      );
      // 商材マスタのマスタ参照用データ作成
      // (ヘッダーはestimate.tsから取得)
      // 商材マスタをサービス種別で絞り込む
      const serviceType = this.serviceType;
      const commodityItemResult = this.masterData['m_commodity'].body.filter(function(recode) {
        if (serviceType === recode.service_type_id) {
          return recode;
        }
      });

      for (const key in commodityItemResult) {
        this.masterCommoditySelectData.push(commodityItemResult[key]);
      }

      // 見積登録では構成明細のデータ作成は0件なので行わない
      // 明細追加入力一覧のデータ作成
      for (const key in this.masterData['m_datail_add_input'].body) {
        this.mastermEstimateDetailAddInputSelectData.push(
          this.masterData['m_datail_add_input'].body[key]
        );
      }
      // 明細追加入力一覧に空行を1行追加する
      const estimateDatailAddInputItem = JSON.parse(
        JSON.stringify(EstimateDatailAddInputBaseFormat)
      );
      estimateDatailAddInputItem['No'] = 1;
      estimateDatailAddInputItem.tax_classification = this.defaultTaxData.name;
      estimateDatailAddInputItem.tax_classification_id = this.defaultTaxData.i_id;
      estimateDatailAddInputItem.tax_rate = this.defaultTaxData.tax_rate;
      this.detailAddListData.push(estimateDatailAddInputItem);
      this.registDatailAddInputItemData.push({
        'item': '',
        'standard_unit_price': 0,
        'purchase_unit_price': 0,
        'quantity': 0,
        'remarks': '',
        'tax_classification_id': this.defaultTaxData.i_id
      });

      // 見積情報タブ内の見積情報を設定(値の設定などはB群のPromise.all後)
      // (新規作成のため、項目はブランク)
      //見積情報関連の処理は不要なためコメントアウト
      // switch (this.screenStructureType) {
      //   case '1': {
      //     // OAリース
      //     this.estimateInformationPanel = this.getHeaderFields(estimateOAInformations);
      //     this.creditEstimateInformationPanel = this.getHeaderFields(creditEstimateOAInformations);
      //     this.estimateInformationsData = {
      //       0: '',
      //       1: '',
      //       2: '',
      //       3: '',
      //       4: '',
      //       5: '',
      //       6: '',
      //       7: '',
      //       8: ''
      //     };
      //     // 見積情報内のリース会社(マスタ参照：料率マスタ)を設定
      //     for (const key in this.masterData['m_rate'].body) {
      //       this.mastermEstimateRateData.push(this.masterData['m_rate'].body[key]);
      //     }
      //     this.estimateInformationPanel.datas[5].props.columns =
      //       EstimateMasterDatas.masterRateColumns;
      //     this.estimateInformationPanel.datas[5].props.body = this.mastermEstimateRateData;
      //     this.creditEstimateInformationPanel.datas[5].props.columns =
      //       EstimateMasterDatas.masterRateColumns;
      //     this.creditEstimateInformationPanel.datas[5].props.body = this.mastermEstimateRateData;
      //     break;
      //   }
      //   case '99': {
      //     // 汎用
      //     this.estimateInformationPanel = this.getHeaderFields(estimateGeneralInformations);
      //     this.estimateInformationsData = {
      //       0: '',
      //       1: '',
      //       2: '',
      //       3: '',
      //       4: ''
      //     };
      //   }
      // }

      // 課税区分マスタを設定
      for (const key in this.masterData['m_tax'].body) {
        this.masterTaxData.push(this.masterData['m_tax'].body[key]);
      }

      // 見積表の作成
      // 見積表に空行を1行追加する
      const estimateDatailItem = JSON.parse(JSON.stringify(EstimateDatailBaseFormat));
      estimateDatailItem['No'] = 1;
      this.detailListData.push(estimateDatailItem);
      // 見積表用登録データの作成
      this.registEstimateDetailItemData.push({
        'item': '',
        'unit_price': 0,
        'purchase_unit_price': 0,
        'quantity': 0,
        'remarks': ''
      });

      // 見積集計情報パネル
      //見積情報関連の処理は不要なためコメントアウト
      // 例外リストに営業利益が存在しない場合は見積集計情報パネル内の営業利益合計は表示しない
      // this.deletePanelItem(estimateInformationSummary, '営業利益合計', 'transfer_amount_price');
      // 例外リストに利益率が存在しない場合は見積集計情報パネル内の営業利益率は表示しない
      // this.deletePanelItem(estimateInformationSummary, '営業利益率', 'profit_rate');
      // 編集した見積集計情報パネルを設定
      // this.estimateInformationSummary = this.getHeaderFields(estimateInformationSummary);
      // 例外リストに営業利益が存在しない場合は営業利益合計、営業利益率に値をセットしない
      // const deletePanelItemIndex = estimateInformationSummary.findIndex(function(recode) {
      //   if (recode.name == 'transfer_amount_price') {
      //     return recode;
      //   }
      // });
      // const estimateInformationSummaryData =
      //   deletePanelItemIndex !== -1
      //     ? {
      //         0: 0,
      //         1: this.estimateInformationSummaryTotalValues('', 'sale_price'),
      //         2: 0,
      //         3: this.estimateInformationSummaryTotalValues('noEstimateDetailList', 'sale_price'),
      //         4: '10',
      //         5: 0,
      //         6: 0,
      //         7: 0,
      //         8: '0' + '%'
      //       }
      //     : {
      //         0: 0,
      //         1: this.estimateInformationSummaryTotalValues('', 'sale_price'),
      //         2: 0,
      //         3: this.estimateInformationSummaryTotalValues('noEstimateDetailList', 'sale_price'),
      //         4: '10',
      //         5: 0,
      //         6: 0
      //       };
      // this.estimateInformationSummaryTaxAmount();
      // this.getHeaderData(estimateInformationSummaryData, this.estimateInformationSummary);

      const addPromises: any = [];

      addPromises.push(
        this.estimate
          .getStatusList(this.projectId, this.estimateDsId)
          .then(data => data[0].statuses)
      );
      addPromises.push(
        this.estimate.makeFieldsList(this.projectId, this.estimateDsId)
      );
      addPromises.push(
        this.estimate.getNewActionList(this.estimateDsId).then(response => {
          // 新規作成のアクションリストから「一時保存する」のアクションを抜出
          const temporarilySaveActionItem = response.actions.find(function(recode: any) {
            if ('temporarily_save' === recode.display_id) {
              return recode;
            }
          });
          this.estimate
            .getFieldsByActionId(this.estimateDsId, temporarilySaveActionItem!.action_id)
            .then(response => {
              this.setRegistFieldType(response, this.registFieldType);
              this.inputFieldChange(this.estimateHeaderData.datas, response);
              this.inputFieldChange(this.estimateSubjectData.datas, response);
              // 商材マスタの必須入力チェック
              for (const index in response.action_fields) {
                if (response.action_fields[index].display_id === 'commodity_id') {
                  Object.keys(response.action_field_settings).forEach(key => {
                    if (
                      response.action_field_settings[key].field_id ===
                      response.action_fields[index].field_id
                    ) {
                      if (
                        response.action_field_settings[key].show !== null ||
                        response.action_field_settings[key].show !== undefined
                      ) {
                        this.$set(
                          this.estimateTabData[0].configurationTableData.masterSelectDataCommodity,
                          'isShow',
                          response.action_field_settings[key].show
                        );
                      }
                      if (
                        response.action_field_settings[key].update !== null ||
                        response.action_field_settings[key].update !== undefined
                      ) {
                        this.$set(
                          this.estimateTabData[0].configurationTableData.masterSelectDataCommodity,
                          'isBtnVisible',
                          response.action_field_settings[key].update
                        );
                      }
                      if (
                        response.action_field_settings[key].mandatory !== null ||
                        response.action_field_settings[key].mandatory !== undefined
                      ) {
                        if (response.action_field_settings[key].mandatory === true) {
                          this.commodityRules = 'required';
                          this.$set(
                            this.estimateTabData[0].configurationTableData
                              .masterSelectDataCommodity,
                            'rules',
                            this.commodityRules
                          );
                        }
                      }
                    }
                  });
                }
              }
            });
          return response;
        })
      );
      if (this.screenStructureType === '2') {
        addPromises.push(
          this.estimate
            .getFieldsData(this.projectId, hexabaseState.datastoreIds['構成表'])
            .then(response => {
              this.setHeaderListColumn(
                response,
                PartsListHeadersFJapan,
                this.estimateTabData[0].configurationTableData.partsList.tableParameters,
                'columns',
                this.exceptionHeaderItem
              );
            })
        );
      } else {
        addPromises.push(
          this.estimate
            .getFieldsData(this.projectId, hexabaseState.datastoreIds['構成表'])
            .then(response => {
              this.setHeaderListColumn(
                response,
                PartsListHeaders,
                this.estimateTabData[0].configurationTableData.partsList.tableParameters,
                'columns',
                this.exceptionHeaderItem
              );
            })
        );
      }

      const results:any = await Promise.all(addPromises);

      const statusList = results[0]
      const actionList = results[2]

      //見積情報関連の処理は不要なためコメントアウト
      // 見積ステータス
      this.displayStatus = statusList ? statusList[0].status_name : 'ステータス取得失敗';
      // this.estimateInformationPanel.datas[1]['props']['displayStatus'] = this.displayStatus;
      // 受注確度の設定
      // this.selectOptions['orderAccuracy'] = estimateFieldsListData.find(
      //   v => v.display_id === 'order_accuracy'
      // );
      // this.estimateInformationPanel.datas[4].props.selectData.options = this.selectOptions[
      //   'orderAccuracy'
      // ].options;

      // this.$set(
      //   this.estimateTabData[1].estimateInformationData.estimateDetailInformation,
      //   'estimateInformationPanel',
      //   this.estimateInformationPanel
      // );

      // this.$set(
      //   this.estimateTabData[1].estimateInformationData.estimateRateTabData[0].configurationTableData.estimateDetailInformation,
      //   'estimateInformationPanel',
      //   this.estimateInformationPanel
      // );
      // this.$set(
      //   this.estimateTabData[1].estimateInformationData.estimateRateTabData[1].configurationTableData.estimateDetailInformation,
      //   'estimateInformationPanel',
      //   this.creditEstimateInformationPanel
      // );

      // this.getHeaderData(this.estimateInformationsData, this.estimateInformationPanel);

      // 各項目の入力項目の状態を設定する
      // 見積基本情報OAまたは見積基本情報汎用トランの必須入力チェック
      const newAction = (() => {
        switch (this.screenStructureType) {
          case '1':
            return 'estimate_basic_infomation_OA_register';
          case '99':
            return 'estimate_basic_infomation_general_register';
          case '2':
            return 'estimate_basic_infomation_fjapan_register';
          default:
        }
      })();

      // const newAction =
      //   this.screenStructureType === '1'
      //     ? 'estimate_basic_infomation_OA_register'
      //     : 'estimate_basic_infomation_general_register';
      const actionItem = actionList.actions.find(function(recode: any) {
        if (newAction === recode.display_id) {
          return recode;
        }
      });
      // 登録用のアクションIDを控えておく
      if (actionItem !== undefined) {
        this.insertActionId = actionItem?.action_id;
      }

      // 権限を取得する
      // デフォルトの新規登録アクション以外を取得できていないなら発注登録権限を持たない
      this.registAuthority = actionItem !== undefined ? true : false;
      this.guideMessage = this.registAuthority ? authorityValidMessage : authorityInvalidMessage;
    } catch (e) {
      this.setError(e);
    } finally {
      this.$store.commit('hexabase/setIsLoading', false);
    }
  }

  private setRegistFieldType(inputFields: ApiData, registFieldType: any) {
    for (const key in inputFields.action_fields) {
      registFieldType[inputFields.action_fields[key].display_id] =
        inputFields.action_fields[key].dataType;
    }
  }

  /**
   * 新規作成アクションメニュー一覧を取得して、
   * 指定されたアクション名から一致したアクションアイテムを返す
   * @module newItemActionExtraction
   * @param {itemActionList} - アイテムアクションリスト
   * @param {actionName} - 検索するアクション名
   */
  private newItemActionExtraction(itemActionList: any, actionName: string) {
    const actionList = itemActionList;
    const actionItem = actionList.actions.find(function(recode: any) {
      if (actionName === recode.display_id) {
        return recode;
      }
    });
    return actionItem;
  }

  /**
   * 一覧内入力フォーマットにルール追加
   * @module listInputFieldRuleCheck
   * @param {setFormatData} - 一覧内入力フォーマット情報
   * @param {inputFields} - フィールド情報
   */
  private listInputFieldRuleCheck(
    setFormatData: Array<{ [k: string]: any }>,
    inputFields: ApiData
  ) {
    for (const index in inputFields.action_fields) {
      for (const indexB in setFormatData) {
        if (inputFields.action_fields[index].display_id === setFormatData[indexB].name) {
          if (inputFields.action_field_settings[index].mandatory === true) {
            setFormatData[indexB].rules.push('table_input_item_required');
          }
        }
      }
    }
  }

  /**
   * 例外リストに指定された項目名が存在しない場合は指定されたパネル内項目を削除する
   * @module deletePanelItem
   * @param {panelItemList} - パネル内項目情報
   * @param {deleteItemName} - 指定されたパネル内項目名
   * @param {exceptionHeaderItemName} - 指定された項目名
   */
  private deletePanelItem(
    panelItemList: FieldChildrenProp[],
    deleteItemName: string,
    exceptionHeaderItemName: string
  ) {
    const deletePanelItemIndex = panelItemList.findIndex(function(recode) {
      if (recode.name == deleteItemName) {
        return recode;
      }
    });
    if (deletePanelItemIndex !== -1) {
      if (!this.exceptionHeaderItem.includes(exceptionHeaderItemName)) {
        panelItemList.splice(deletePanelItemIndex, 1);
      }
    }
  }

  /**
   * フィールド情報を取得して、指定の場所に設定する
   * @module setHeaderListColumn
   */
  private setHeaderListColumn(
    inputFields: any,
    baseListColumn: any,
    setItem: any,
    setArea: string,
    exceptionColumnItem: Array<string> = []
  ) {
    const listColumn = JSON.parse(JSON.stringify(baseListColumn));
    // header内容の書き換え
    this.listHeaderCreate(inputFields, listColumn, exceptionColumnItem);
    this.$set(setItem, setArea, listColumn);
  }

  /**
   * フィールド情報とカラム情報を突き合わせて、不要なカラムを削除
   * @module listHeaderCreate
   */
  private listHeaderCreate(
    listInputField: any,
    listColumn: any,
    exceptionColumnItem: Array<string> = []
  ) {
    const noHeaderName: any = [];
    for (const index in listColumn) {
      const searchItem: any = listColumn[index];
      let setHeaderItem: any;
      Object.keys(listInputField.fields).forEach(key => {
        // 振替・仕入単位の項目がある場合に合計となる振替・仕入金額(参照用も含む)、、営業利益、利益率を表示する為、
        // 例外リスト表示項目を追加する際に追加済のチェックを行い、存在しない場合は追加する
        if ('transfer_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_transfer_unit_price')) {
            exceptionColumnItem.push('reference_transfer_unit_price');
          }
          if (!exceptionColumnItem.includes('transfer_amount_price')) {
            exceptionColumnItem.push('transfer_amount_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        } else if ('purchase_unit_price' === listInputField.fields[key].display_id) {
          if (!exceptionColumnItem.includes('reference_purchase_unit_price')) {
            exceptionColumnItem.push('reference_purchase_unit_price');
          }
          if (!exceptionColumnItem.includes('purchasing_price')) {
            exceptionColumnItem.push('purchasing_price');
          }
          if (!exceptionColumnItem.includes('operating_income')) {
            exceptionColumnItem.push('operating_income');
          }
          if (!exceptionColumnItem.includes('profit_rate')) {
            exceptionColumnItem.push('profit_rate');
          }
        }

        if (listInputField.fields[key].display_id === listColumn[index].value) {
          setHeaderItem = listColumn[index];
          return;
        }
      });

      if (setHeaderItem === undefined) {
        // トランやマスタに入っていない
        const exceptionItem = exceptionColumnItem.find(function(item) {
          if (searchItem.value === item) {
            return item;
          }
        });

        if (exceptionItem === undefined) {
          noHeaderName.push(listColumn[index].value);
        }
      }
    }
    for (const index in noHeaderName) {
      const searchIndex = listColumn.findIndex(function(item: any) {
        if (item.value === noHeaderName[index]) {
          return item;
        }
      });
      if (searchIndex !== -1) {
        listColumn.splice(searchIndex, 1);
      }
    }
  }

  /**
   * inputFieldsで入力項目の状態を変更
   * @module inputFieldChange
   * @param {itemDatas} - 項目情報
   * @param {inputFields} - フィールド情報
   */
  private async inputFieldChange(itemDatas: any, inputFields: GetInputFieldsActons) {
    const fieldItems: any = [];
    for (const index in inputFields.action_fields) {
      for (const indexB in itemDatas) {
        if (inputFields.action_fields[index].display_id === itemDatas[indexB].display_id) {
          Object.keys(inputFields.action_field_settings).forEach(key => {
            if (
              inputFields.action_field_settings[key].field_id ===
              inputFields.action_fields[index].field_id
            ) {
              fieldItems.push({
                action_field_settings: inputFields.action_field_settings[key],
                action_fields: inputFields.action_fields[index]
              });
            }
          });
        }
      }
    }

    for (const index in fieldItems) {
      itemDatas.find((recode: any) => {
        if (fieldItems[index].action_fields.display_id === recode.display_id) {
          if (fieldItems[index].action_field_settings.mandatory === true) {
            recode.props.rules = 'required';
          }
          if (
            fieldItems[index].action_field_settings.show !== null ||
            fieldItems[index].action_field_settings.show !== undefined
          ) {
            recode.show = fieldItems[index].action_field_settings.show;
          }
          if (
            fieldItems[index].action_field_settings.update !== null ||
            fieldItems[index].action_field_settings.update !== undefined
          ) {
            recode.props.isReadonly =
              fieldItems[index].action_field_settings.update === true ? false : true;
            recode.props.isDisabled =
              fieldItems[index].action_field_settings.update === true ? false : true;
          }
          if (recode.component === 'DatePickerArea' || recode.component === 'SelectArea') {
            recode.props.isDisabled =
              fieldItems[index].action_field_settings.update === true ? false : true;
          } else if (recode.component === 'MasterSelectMultiSetControl') {
            recode.props.isBtnVisible = fieldItems[index].action_field_settings.update;
          }

          // 見積番号を必須入力にする。
          // ※見積番号は自由入力の為、HexabaseUIで「一時保存する」を必須にすると
          // 見積コピーの際にエラーになるのでフロント側で必須に設定
          if (fieldItems[index].action_fields.display_id === 'estimate_id') {
            recode.props.rules = 'required';
          }
        }
      });
    }

    // 表示項目をフィルタする
    const showField = itemDatas.filter((field: any) => field.show === true);
    // 表示項目のデータが持つ行番号を控える
    const rowGroupArray = [];
    for (const key in showField) {
      rowGroupArray.push(showField[key].row);
    }
    const rowGroupRecord: Array<any> = [];
    Array.from(new Set(rowGroupArray)).forEach(function(element, index) {
      rowGroupRecord[index] = showField.filter((field: any) => field.row === element);
    });
    for (const row in rowGroupRecord) {
      // col順でソートする
      rowGroupRecord[row].sort(function(a: any, b: any) {
        return a.col - b.col;
      });
      let previousCol = 0;
      let previousSizeX = 0;
      for (const key in rowGroupRecord[row]) {
        // 前項目のcol+sizeXの値が現在のcolと等しくない場合は、col+sizeXの値に変更する
        if (previousCol + previousSizeX !== rowGroupRecord[row][key].col) {
          rowGroupRecord[row][key].col = previousCol + previousSizeX;
        }
        previousCol = rowGroupRecord[row][key].col;
        previousSizeX = rowGroupRecord[row][key].sizeX;
      }
    }
  }

  private optionItemDataSearch(itemDatas: any, searchString: string) {
    const searchItem = itemDatas.find(function(item: any) {
      if (searchString === item.display_id) {
        return item;
      }
    });
    return searchItem;
  }

  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputSummaryPanel
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputSummaryPanel(response: any) {
    if (response.name == 'sales_tax_rate') {
      //見積情報関連の処理は不要なためコメントアウト
      // this.estimateInformationSummaryTaxAmount();
      // this.$set(this.estimateInformationSummary.datas[4].props, 'value', response.value);
      this.registData.item['sales_tax_rate'] = Number(response.value);
    } else if (response.name == '値引') {
      this.registData.item['discount_amount'] = response.value;
    }
  }

  private inputBasicPanelCheck: any = '';
  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasicPanel
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasicPanel(response: any) {
    if (response.value !== '') {
      this.inputBasicPanelCheck = response.value;
    }
  }

  private inputBasicPanelCheckArray: any = [];
  /**
   * 子コンポーネントからEmitされる値インサート用に加工（基本情報）
   * 主にPropsの変更を行う
   * @module catchInputBasicPanel
   * @param {any} response - 子コンポーネントより渡される値
   * @return {void}
   */
  private catchInputBasicTabPanel(response: any) {
    if (response.value !== '') {
      if (response.index === 1) {
        this.inputBasicPanelCheckArray[response.index] = response.value;
      }
    }
  }

  /**
   * ルーター設定ファイルよりパンくずリスト取得
   * @module getBreadCrumbs
   * @return {array} - breadcrumbs 情報
   */
  private getBreadCrumbs(): [] {
    if (this.$route.matched.some(obj => obj.meta.breadcrumbs)) {
      return this.$route.meta.breadcrumbs;
    }
    return [];
  }

  /**
   * アクションパネルのボタンを押下した際の次処理を進める
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private async execAction(type: any) {
    switch (type) {
      case 'register':
      case 'temporarily_save': {
        if (this.fractionValue !== 0) {
          this.isExecDialog = true;
          this.execActionType = type;
        } else {
          try {
            // ローディングをセット
            this.$store.commit('hexabase/setIsLoading', true);
            switch (type) {
              case 'register': {
                // 登録
                this.registData['action_id'] = this.insertActionId;
                break;
              }
              case 'temporarily_save': {
                // 一時保存
                this.registData['action_id'] = 'temporarily_save';
                break;
              }
              default: {
                break;
              }
            }
            // 関連付ける案件サービス別(OA、汎用、F=Japan)トランの設定
            this.registData['related_ds_items'][this.matterServiceDsId] = [
              {
                'operation': 11,
                'link_to_parent': true,
                'i_id': this.projectServiceItemId
              }
            ];

            this.addRelatedDsItem(
              '構成表',
              this.registMaterialItemData,
              ['standard_unit_price', 'transfer_unit_price', 'quantity'],
              'material_id'
            );
            this.addRelatedDsItem(
              '明細追加入力',
              this.registDatailAddInputItemData,
              ['standard_unit_price', 'purchase_unit_price', 'quantity'],
              'datail_add_input_id'
            );
            this.addRelatedDsItem(
              '見積明細',
              this.registEstimateDetailItemData,
              ['unit_price', 'purchase_unit_price', 'quantity'],
              'estimate_detail_id'
            );

            const result = await this.estimate.registerLinkedItems(
              hexabaseState.applicationId,
              this.estimateDsId,
              this.registData
            );
            this.estimate.apiErrorHandle('CREATEITEM', result);
            this.registerText = this.estimate.deepCopy(registerFinishText);
            this.buttons.map(v => {
              if (v.name === 'toEdit') {
                v.route = String(v.route).replace(':datastoreId', this.estimateDsId);
                v.route = String(v.route).replace(':id', result.item_id);
              }
            });
          } catch (e) {
            console.log(e);
            this.registerText = 'エラーにより処理できませんでした';
            this.buttons.splice(0);
            this.buttons.push({ id: 1, type: 'cancel', name: 'cancel', value: '閉じる' });
          } finally {
            this.$store.commit('hexabase/setIsLoading', false);
            this.dialogStatus = true;
          }
        }

        break;
      }
      case 'cancel': {
        this.$router.push({ name: 'MatterEdit', params: { id: this.passedItemId } });
      }
    }
  }

  private addRelatedDsItem(
    dbName: string,
    baseDatas: any,
    registNames: Array<string>,
    checkId: string
  ) {
    if (baseDatas.length !== 0) {
      this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]] = [];

      // 指定された項目が存在する場合のみフィルタリング登録対象に含む
      const resultItem = baseDatas.filter(function(recode: any) {
        if (recode[checkId] !== null && recode[checkId] !== undefined) {
          return recode;
        }
      });
      for (const index in resultItem) {
        // 見積番号(見積ID)があったら、追加
        if (this.estimateId !== '') {
          resultItem[index]['estimate_id'] = this.estimateId;
        }
        // 登録用に値を型変換
        for (const indexB in registNames) {
          resultItem[index][registNames[indexB]] = Number(resultItem[index][registNames[indexB]]);
        }

        // 表示順の追加
        resultItem[index]['display_order'] = Number(index) + 1;
        // API用登録データに追加
        this.registData['related_ds_items'][hexabaseState.datastoreIds[dbName]].push({
          'operation': 1,
          'link_to_parent': true,
          'item': resultItem[index]
        });
      }
    }
  }

  /**
   * アイテムを登録後ダイアログ表示等を初期化します
   * @returns {void} - 内部プロパティ変更
   */
  private registerFinish(): void {
    this.dialogStatus = false;
    this.isLoading = false;
  }

  private getHeaderFields(formData: any) {
    const baseData = {
      cols: {},
      datas: {} as { [k: string]: any }
    };
    try {
      baseData.cols = this.estimate.getGridStatus(formData);
      baseData.datas = formData;
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
    return baseData;
  }

  private getHeaderData(setData: { [key: string]: any }, baseData: any) {
    try {
      Object.keys(setData).map((key: string) => {
        baseData.datas[key].props['value'] = setData[key];
      });
    } catch (errorMessage) {
      this.setError(errorMessage);
    }
  }

  private setError(errorMessage: any) {
    if (typeof errorMessage === 'object') errorMessage = this.estimate.getDefaultErrorMessage();
    // エラーをキャッチした際共通エラーダイアログにセット
    this.$store.commit('hexabase/setIsError', true);
    this.$store.commit('hexabase/setErrorMessage', errorMessage);
  }

  /**
   * 案件基本情報パネル内入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private catchHeaderInput(response: any) {
    const item = this.estimateHeaderData.datas.find(function(recode: any) {
      if (recode.display_id === response.name) {
        return recode;
      }
    });
    item.props.value = response.value;
    this.registData.item[response.name] = response.value;
    this.estimateId = response.value;
  }

  /**
   * 見積基本情報(見積件名、見積版名)パネル内入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private catchInputEstimateSubject(response: any) {
    const item = this.estimateSubjectData.datas.find(function(recode: any) {
      if (recode.display_id === response.name) {
        return recode;
      }
    });
    item.props.value = response.value;
    this.registData.item[response.name] = response.value;
  }

  /**
   * タブ内パネル入力イベント
   * @param {string} - イベント情報として押下したボタン種類が返ってくる
   */
  private tabChildrenEvent(response: any) {
    let buttonName = '';
    let listName = '';

    switch (response.functionName) {
      case 'clickCheckBoxEventRelay': {
        // チェックボックスの状態に合わせて、
        // 構成表内の各項目で数量がゼロの行を表示・非表示にする
        this.checkBoxsStatus = response.zero_visible;
        if (this.checkBoxsStatus === true) {
          this.partsListViewData = this.filterDataItem(
            JSON.parse(JSON.stringify(this.partsListBaseData)),
            'quantity',
            0,
            false
          );
          for (const index in this.partsListViewData) {
            this.partsListViewData[index]['No'] = Number(index) + 1;
          }
        } else {
          this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
        }

        this.$set(
          this.estimateTabData[0].configurationTableData.partsList.tableParameters,
          'body',
          this.partsListViewData
        );
        break;
      }
      case 'getdataRelay':
      case 'clickItemAdditionButtonRelay': {
        if (response.buttonName || response.listName) {
          buttonName = response.buttonName;
          listName = response.listName;
        } else if (response.selectRowData.buttonName) {
          buttonName = response.selectRowData.buttonName;
          listName = response.selectRowData.listName;
        }
        switch (listName) {
          case '構成明細': {
            switch (buttonName) {
              case 'taxClassificationButton': {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.partsList.tableParameters[
                      'body'
                    ][response.selectRowData.itemIndex]
                  )
                );
                item['tax_classification_id'] = response.selectData['i_id'];
                item['tax_classification'] = response.selectData['name'];
                item['tax_rate'] = response.selectData['tax_rate'];
                this.$set(
                  this.estimateTabData[0].configurationTableData.partsList.tableParameters['body'],
                  response.selectRowData.itemIndex,
                  item
                );
                this.registMaterialItemData[response.selectRowData.itemIndex][
                  'tax_classification_id'
                ] = response.selectData['i_id'];
                break;
              }
              default: {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.partsList.tableParameters[
                      'body'
                    ][response.itemIndex]
                  )
                );
                if (response.inputName === 'remarks') {
                  if (response.inputValue !== null) {
                    item[response.inputName] = String(response.inputValue);
                  } else {
                    item[response.inputName] = '';
                  }
                } else {
                  item[response.inputName] = Number(response.inputValue);
                }
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['transfer_amount_price'] = item['transfer_unit_price'] * item['quantity'];
                item['operating_income'] = this.calculationModel.operatingIncome(
                  item['sale_price'],
                  item['transfer_amount_price']
                );
                item['profit_rate'] = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(
                    item['sale_price'],
                    item['transfer_amount_price']
                  ),
                  item['sale_price'],
                  this.defaultRoundingType
                );

                this.$set(
                  this.estimateTabData[0].configurationTableData.partsList.tableParameters['body'],
                  response.itemIndex,
                  item
                );
                // 構成表のベースデータにも反映する
                const index = this.dataFindIndex(this.partsListBaseData, 'id', item.id);
                if (index !== -1) {
                  this.partsListBaseData[index] = item;
                }
                // 登録データに追加
                this.registMaterialItemData[index][response.inputName] = response.inputValue;
                break;
              }
            }
            break;
          }
          case '明細追加入力一覧': {
            switch (buttonName) {
              case 'copyButton': {
                const itemLimit = Number(appState.options['見積詳細']['明細追加入力一覧']['追加上限数'])
                const itemAmount = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'].length;
                if (itemAmount < itemLimit) {
                  const items = this.estimateTabData[0].configurationTableData.detailAddList
                    .tableParameters['body'];
                  const item = JSON.parse(JSON.stringify(items[response.itemIndex]));
                  items.splice(response.itemIndex, 0, item);
                  // 登録用データ
                  if (this.registDatailAddInputItemData[response.itemIndex] !== undefined) {
                    const registItem = JSON.parse(
                      JSON.stringify(this.registDatailAddInputItemData[response.itemIndex])
                    );
                    this.registDatailAddInputItemData.splice(response.itemIndex + 1, 0, registItem);
                  }
                  // 表示用Noとidの振りなおし
                  for (const index in items) {
                    items[index]['No'] = Number(index) + 1;
                    items[index]['id'] = Number(index) + 1;
                  }
                } else {
                  this.alertDialogMessage = EstimateFractionRoundWording.alertOverAddItems.message;
                  this.alertDialogTitle = EstimateFractionRoundWording.alertOverAddItems.title;
                  this.isAlertDialog = true;
                }
                break;
              }
              case 'deleteButton': {
                // 明細追加入力一覧の表示データ削除
                this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                  'body'
                ].splice(response.itemIndex, 1);
                const items = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'];
                for (const index in this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body']) {
                  items[index]['No'] = Number(index) + 1;
                  items[index]['id'] = Number(index) + 1;
                }
                // 明細追加入力一覧の登録データ削除
                this.registDatailAddInputItemData.splice(response.itemIndex, 1);
                break;
              }
              case 'selectButtonIndex': {
                const item = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'][response.selectRowData.itemIndex];
                item['display_datail_add_input_id'] =
                  response.selectData['display_datail_add_input_id'];
                item['item_code'] = response.selectData['item_code'];
                item['item'] = response.selectData['item'];
                item['standard_unit_price'] = response.selectData['standard_unit_price'];
                if (response.selectData['purchase_unit_price'] !== undefined) {
                  item['reference_purchase_unit_price'] = JSON.parse(
                    JSON.stringify(response.selectData['purchase_unit_price'])
                  );
                }
                item['purchase_unit_price'] = response.selectData['purchase_unit_price'];
                item['classification_id'] = response.selectData['classification_id'];
                item['classification'] = response.selectData['classification_id'];
                item['type_id'] = response.selectData['type_id'];
                item['type'] = response.selectData['type_id'];
                item['remarks'] = response.selectData['remarks'];
                item['input_flag'] = JSON.parse(response.selectData['input_flag'].toLowerCase());
                // 計算関係の値も初期化
                item['quantity'] = 0;
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = 0;
                item['profit_rate'] = '0%';
                item['tax_classification_id'] = this.defaultTaxData.i_id;
                item['tax_classification'] = this.defaultTaxData.name;
                item['tax_rate'] = this.defaultTaxData.tax_rate;
                // 課税区分編集可否フラグ
                item['tax_classification_edit_flag'] = response.selectData['tax_classification_edit_flag'];
                // 明細追加入力一覧用登録データの作成
                this.registDatailAddInputItemData[response.selectRowData.itemIndex] = {
                  'item': item['item'],
                  'datail_add_input_id': response.selectData['i_id'],
                  'standard_unit_price': Number(item['standard_unit_price']),
                  'purchase_unit_price': Number(item['purchase_unit_price']),
                  'quantity': Number(item['quantity']),
                  'remarks': item['remarks'],
                  'tax_classification_id': this.defaultTaxData.i_id
                };
                break;
              }
              case 'addListItem': {
                const itemLimit = Number(appState.options['見積詳細']['明細追加入力一覧']['追加上限数'])
                const itemAmount = this.estimateTabData[0].configurationTableData.detailAddList
                  .tableParameters['body'].length;
                if (itemAmount < itemLimit) {
                  const items = this.estimateTabData[0].configurationTableData.detailAddList
                    .tableParameters['body'];
                  const estimateDatailAddInputItem = JSON.parse(
                    JSON.stringify(EstimateDatailAddInputBaseFormat)
                  );
                  estimateDatailAddInputItem['No'] = Number(items.length) + 1;
                  estimateDatailAddInputItem['id'] = Number(items.length) + 1;
                  estimateDatailAddInputItem['tax_classification_id'] = this.defaultTaxData.i_id;
                  estimateDatailAddInputItem['tax_classification'] = this.defaultTaxData.name;
                  estimateDatailAddInputItem['tax_rate'] = this.defaultTaxData.tax_rate;
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ].push(estimateDatailAddInputItem);
                  // 明細追加入力一覧用登録データの作成
                  this.registDatailAddInputItemData.push({
                    'item': '',
                    'standard_unit_price': 0,
                    'purchase_unit_price': 0,
                    'quantity': 0,
                    'remarks': '',
                    'tax_classification_id': this.defaultTaxData.i_id
                  });
                } else {
                  this.alertDialogMessage = EstimateFractionRoundWording.alertOverAddItems.message;
                  this.alertDialogTitle = EstimateFractionRoundWording.alertOverAddItems.title;
                  this.isAlertDialog = true;
                }
                break;
              }
              case 'taxClassificationButton': {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                      'body'
                    ][response.selectRowData.itemIndex]
                  )
                );
                item['tax_classification_id'] = response.selectData['i_id'];
                item['tax_classification'] = response.selectData['name'];
                item['tax_rate'] = response.selectData['tax_rate'];
                this.$set(
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ],
                  response.selectRowData.itemIndex,
                  item
                );
                this.registDatailAddInputItemData[response.selectRowData.itemIndex][
                  'tax_classification_id'
                ] = response.selectData['i_id'];
                break;
              }
              default: {
                const item = JSON.parse(
                  JSON.stringify(
                    this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                      'body'
                    ][response.itemIndex]
                  )
                );
                if (response.inputName === 'remarks' || response.inputName === 'item') {
                  if (response.inputValue !== null) {
                    item[response.inputName] = String(response.inputValue);
                  } else {
                    item[response.inputName] = '';
                  }
                } else {
                  item[response.inputName] = Number(response.inputValue);
                }
                item['sale_price'] = item['standard_unit_price'] * item['quantity'];
                item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
                item['operating_income'] = this.calculationModel.operatingIncome(
                  item['sale_price'],
                  item['purchasing_price']
                );
                item['profit_rate'] = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(
                    item['sale_price'],
                    item['purchasing_price']
                  ),
                  item['sale_price'],
                  this.defaultRoundingType
                );

                this.$set(
                  this.estimateTabData[0].configurationTableData.detailAddList.tableParameters[
                    'body'
                  ],
                  response.itemIndex,
                  item
                );
                // 選択から明細追加入力マスタの内容が選ばれてない場合は登録しない
                if (this.registDatailAddInputItemData.length !== 0) {
                  this.registDatailAddInputItemData[response.itemIndex][response.inputName] =
                    response.inputValue;
                }
                break;
              }
            }
            break;
          }
          //見積情報関連の処理は不要なためコメントアウト
          // case '見積表': {
          //   switch (buttonName) {
          //     case 'copyButton': {
          //       const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
          //         .tableParameters['body'];
          //       const item = JSON.parse(JSON.stringify(items[response.itemIndex]));
          //       items.splice(response.itemIndex, 0, item);
          //       // 登録用データ
          //       if (this.registEstimateDetailItemData[response.itemIndex] !== undefined) {
          //         const registItem = JSON.parse(
          //           JSON.stringify(this.registEstimateDetailItemData[response.itemIndex])
          //         );
          //         this.registEstimateDetailItemData.splice(response.itemIndex + 1, 0, registItem);
          //       }
          //       // 表示用Noとidの振りなおし
          //       for (const index in items) {
          //         items[index]['No'] = Number(index) + 1;
          //         items[index]['id'] = Number(index) + 1;
          //       }
          //       break;
          //     }
          //     case 'deleteButton': {
          //       this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
          //         'body'
          //       ].splice(response.itemIndex, 1);
          //       const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
          //         .tableParameters['body'];
          //       for (const index in this.estimateTabData[1].estimateInformationData
          //         .estimateDetailList.tableParameters['body']) {
          //         items[index]['No'] = Number(index) + 1;
          //         items[index]['id'] = Number(index) + 1;
          //       }
          //       this.registEstimateDetailItemData.splice(response.itemIndex, 1);
          //       break;
          //     }
          //     case 'selectButtonIndex': {
          //       const item = this.estimateTabData[1].estimateInformationData.estimateDetailList
          //         .tableParameters['body'][response.selectRowData.itemIndex];
          //       item['display_estimate_detail_id'] =
          //         response.selectData['display_estimate_detail_id'];
          //       item['classification_id'] = response.selectData['classification_id'];
          //       item['classification'] = response.selectData['classification_id'];
          //       item['type_id'] = response.selectData['type_id'];
          //       item['type'] = response.selectData['type_id'];
          //       item['item'] = response.selectData['item'];
          //       item['unit_price'] = response.selectData['unit_price'];
          //       if (response.selectData['purchase_unit_price'] !== undefined) {
          //         item['reference_purchase_unit_price'] = JSON.parse(
          //           JSON.stringify(response.selectData['purchase_unit_price'])
          //         );
          //       }
          //       item['purchase_unit_price'] = response.selectData['purchase_unit_price'];
          //       item['remarks'] =
          //         response.selectData['remarks'] !== undefined
          //           ? response.selectData['remarks']
          //           : '';
          //       item['input_flag'] = JSON.parse(response.selectData['input_flag'].toLowerCase());
          //       // 計算関係の値も初期化
          //       item['quantity'] = 0;
          //       item['sale_price'] = item['unit_price'] * item['quantity'];
          //       item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
          //       item['operating_income'] = 0;
          //       item['profit_rate'] = '0%';

          //       // 見積表用登録データの作成
          //       this.registEstimateDetailItemData[response.selectRowData.itemIndex] = {
          //         'item': item['item'],
          //         'estimate_detail_id': response.selectData['i_id'],
          //         'unit_price': Number(item['unit_price']),
          //         'purchase_unit_price': Number(item['purchase_unit_price']),
          //         'quantity': Number(item['quantity']),
          //         'remarks': item['remarks']
          //       };
          //       break;
          //     }
          //     case 'addListItem': {
          //       const items = this.estimateTabData[1].estimateInformationData.estimateDetailList
          //         .tableParameters['body'];
          //       const estimateDatailInputItem = JSON.parse(
          //         JSON.stringify(EstimateDatailBaseFormat)
          //       );
          //       estimateDatailInputItem['No'] = Number(items.length) + 1;
          //       estimateDatailInputItem['id'] = Number(items.length) + 1;
          //       this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters[
          //         'body'
          //       ].push(estimateDatailInputItem);
          //       // 見積表用登録データの作成
          //       this.registEstimateDetailItemData.push({
          //         'item': '',
          //         'unit_price': 0,
          //         'purchase_unit_price': 0,
          //         'quantity': 0,
          //         'remarks': ''
          //       });
          //       break;
          //     }
          //     default: {
          //       const item = JSON.parse(
          //         JSON.stringify(
          //           this.estimateTabData[1].estimateInformationData.estimateDetailList
          //             .tableParameters['body'][response.itemIndex]
          //         )
          //       );
          //       if (response.inputName === 'remarks' || response.inputName === 'item') {
          //         if (response.inputValue !== null) {
          //           item[response.inputName] = String(response.inputValue);
          //         } else {
          //           item[response.inputName] = '';
          //         }
          //       } else {
          //         item[response.inputName] = Number(response.inputValue);
          //       }
          //       item['sale_price'] = item['unit_price'] * item['quantity'];
          //       item['purchasing_price'] = item['purchase_unit_price'] * item['quantity'];
          //       item['operating_income'] = this.calculationModel.operatingIncome(
          //         item['sale_price'],
          //         item['purchasing_price']
          //       );
          //       item['profit_rate'] = this.calculationModel.profitRate(
          //         this.calculationModel.operatingIncome(
          //           item['sale_price'],
          //           item['purchasing_price']
          //         ),
          //         item['sale_price'],
          //         this.defaultRoundingType
          //       );

          //       this.$set(
          //         this.estimateTabData[1].estimateInformationData.estimateDetailList
          //           .tableParameters['body'],
          //         response.itemIndex,
          //         item
          //       );

          //       // 選択から明細追加入力マスタの内容が選ばれてない場合は登録しない
          //       if (this.registEstimateDetailItemData.length !== 0) {
          //         this.registEstimateDetailItemData[response.itemIndex][response.inputName] =
          //           response.inputValue;
          //       }
          //       break;
          //     }
          //   }
          //   break;
          // }
        }
        // 税率毎のサマリを作成
        const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
          'body'
        ].concat(
          this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
          //見積情報関連の処理は不要なためコメントアウト
          // this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
        );
        this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
        break;
      }
      case 'masterSelectEventRelay': {
        // 商材マスタ参照の選択時、ダイヤログのクローズは親コンポーネントで行う
        const masterSelectDataCommodity = this.estimateTabData[0].configurationTableData
          .masterSelectDataCommodity;
        // 商材マスタ参照の選択時、ダイヤログのローディング表示を行う
        this.$set(masterSelectDataCommodity, 'isLoadingFlag', true);
        try {
          // 商材マスタから選択された商材を構成明細に表示する
          if (this.partsListViewData.length !== 0) {
            this.partsListViewData = [];
            this.partsListBaseData = [];
            this.$set(
              this.estimateTabData[0].configurationTableData.partsList.tableParameters,
              'body',
              []
            );
            // 登録データも初期化
            this.registMaterialItemData = [];
          }
          const commodityItem = this.masterCommoditySelectData.find(function(recode: any) {
            if (recode.i_id === response.value) {
              return recode;
            }
          });

          if (commodityItem !== undefined) {
            this.registData.item['commodity_id'] = commodityItem['i_id'];
          }

          const selectItemResult = this.masterData['m_material'].body.filter(function(recode) {
            if (commodityItem?.commodity === recode.commodity_id) {
              return recode;
            }
          });

          for (const key in selectItemResult) {
            const baseItems = JSON.parse(JSON.stringify(selectItemResult[key]));
            baseItems['No'] = Number(key) + 1;
            baseItems['quantity'] = 0;
            baseItems['quantity_lower_limit'] = 0;
            baseItems['quantity_upper_limit'] = 0;
            baseItems['unit_lower_limit'] = 0;
            baseItems['unit_upper_limit'] = 0;
            if (baseItems['transfer_unit_price'] !== undefined) {
              baseItems['reference_transfer_unit_price'] = JSON.parse(
                JSON.stringify(baseItems['transfer_unit_price'])
              );
            }
            baseItems['sale_price'] = baseItems['standard_unit_price'] * baseItems['quantity'];
            baseItems['transfer_amount_price'] =
              baseItems['transfer_unit_price'] * baseItems['quantity'];
            baseItems['operating_income'] = this.calculationModel.operatingIncome(
              baseItems['sale_price'],
              baseItems['transfer_amount_price']
            );
            baseItems['profit_rate'] = this.calculationModel.profitRate(
              this.calculationModel.operatingIncome(
                baseItems['sale_price'],
                baseItems['transfer_amount_price']
              ),
              baseItems['sale_price'],
              this.defaultRoundingType
            );
            baseItems['tax_classification_id'] = this.defaultTaxData.i_id;
            baseItems['tax_classification'] = this.defaultTaxData.name;
            baseItems['tax_rate'] = this.defaultTaxData.tax_rate;

            // 選択した商材の編集可・不可フラグで入力とボタンの制御('true'の場合に編集不可)
            let registRditMaterialFlag = '';
            let registRditPriceFlag = '';
            if (commodityItem.template_edit_only_flag !== undefined) {
              baseItems['edit_material_flag'] = commodityItem.template_edit_only_flag.toLowerCase() === 'true' ? false : true;
              baseItems['buttonDisabled'] = commodityItem.template_edit_only_flag.toLowerCase() === 'true' ? true : false;
              registRditMaterialFlag = commodityItem.template_edit_only_flag.toLowerCase() === 'true' ? 'false' : 'true';

              baseItems['edit_price_flag'] = commodityItem.template_edit_only_flag.toLowerCase() === 'true' ? false : true;
            } else {
              baseItems['edit_material_flag'] = true;
              baseItems['buttonDisabled'] = false;
              registRditMaterialFlag = 'true';
              registRditPriceFlag = 'true';
            }

            this.partsListBaseData.push(JSON.parse(JSON.stringify(baseItems)));

            // 構成明細用登録データの作成
            this.registMaterialItemData.push({
              'service_type_id': this.serviceTypeItemId,
              'material_id': baseItems['i_id'],
              'standard_unit_price': Number(baseItems['standard_unit_price']),
              'unit_lower_limit': Number(baseItems['unit_lower_limit']),
              'unit_upper_limit': Number(baseItems['unit_upper_limit']),
              'transfer_unit_price': Number(baseItems['transfer_unit_price']),
              'quantity': Number(baseItems['quantity']),
              'quantity_lower_limit': Number(baseItems['quantity_lower_limit']),
              'quantity_upper_limit': Number(baseItems['quantity_upper_limit']),
              'remarks': baseItems['remarks'],
              'tax_classification_id': baseItems['tax_classification_id'],
              'edit_material_flag': registRditMaterialFlag,
              'edit_price_flag': registRditPriceFlag
            });
          }

          // チェックボックスの状態に合わせて、
          // 構成表内の各項目で数量がゼロの行を表示・非表示にする
          if (this.checkBoxsStatus === true) {
            this.partsListViewData = this.filterDataItem(
              JSON.parse(JSON.stringify(this.partsListBaseData)),
              'quantity',
              0,
              false
            );
            for (const index in this.partsListViewData) {
              this.partsListViewData[index]['No'] = Number(index) + 1;
            }
          } else {
            this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
          }

          this.$set(
            this.estimateTabData[0].configurationTableData.partsList.tableParameters,
            'body',
            this.partsListViewData
          );
          //テンプレートをセレクトボックスにロードする
          const getBody = this.masterData['m_materialtemplate'].body.filter(v => v.commodity_id === commodityItem['commodity']);
          if (getBody !== undefined && getBody.length > 0) {
            this.mtempleteSelectDataOption.splice(0, this.mtempleteSelectDataOption.length);
            getBody.forEach(v => {
              this.mtempleteSelectDataOption.push({ text: v.template_name, value: v.i_id });
            });
            // ボックスをを活性
            this.$set(this.estimateTabData[0].configurationTableData.vmSelectDataTemplete, 'isDisabled', false);
          }
          // 税率毎のサマリを作成
          const mergeDetails = this.estimateTabData[0].configurationTableData.partsList.tableParameters[
            'body'
          ].concat(
            this.estimateTabData[0].configurationTableData.detailAddList.tableParameters['body'],
            //見積情報関連の処理は不要なためコメントアウト
            // this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters['body']
          );
          this.taxData = this.createGroupByTaxClassificationId(mergeDetails);
        } catch (e) {
          this.setError(e);
        } finally {
          if (masterSelectDataCommodity.isParentDialogControlFlag === true) {
            // 商材マスタ参照の選択時、ダイヤログのクローズは親コンポーネントからダイヤログ閉じる
            setTimeout(() => {
              this.$set(masterSelectDataCommodity, 'isLoadingFlag', false);
            }, Number(this.estimateTabData[0].configurationTableData.partsList.tableParameters.body.length * 25));
          }
        }
        break;
      }
      case 'catchInputRelay': {
        switch (response.name) {
          case 'order_accuracy': {
            if (response.text !== '') {
              const item = this.selectOptions['orderAccuracy']['options'].find(
                (recode: any) => recode.text === response.text
              );
              //見積情報関連の処理は不要なためコメントアウト
              // this.estimateInformationPanel.datas[4].props.value = item;
              // 登録用にoption_idをセット
              this.registData.item['order_accuracy'] = item.option_id;
            }
            break;
          }
          //見積情報関連の処理は不要なためコメントアウト
          // case 'leasing_company_id': {
          //   const item = this.mastermEstimateRateData.find(
          //     (recode: any) => recode.i_id === response.value
          //   );
          //   this.estimateInformationPanel.datas[5].props.value = response.value;
          //   this.estimateInformationPanel.datas[6].props.value =
          //     item['contract_months_calculation'];
          //   this.estimateInformationPanel.datas[7].props.value = item['rate'];
          //   const cost = this.calculationModel.monthlyLeaseCost(
          //     this.estimateInformationSummary.datas[6].props.value,
          //     Number(item['rate'])
          //   );
          //   this.estimateInformationPanel.datas[8].props.value = cost;
          //   this.fractionValue = this.calculationModel.fractionProcess(cost);
          //   const leasingCompanyItem = this.masterData['m_leasing_company'].body.find(
          //     (recode: any) => recode['leasing_company'] === item['leasing_company_id']
          //   );
          //   if (leasingCompanyItem !== undefined) {
          //     this.registData.item['leasing_company_id_internal'] = leasingCompanyItem['i_id'];
          //   }
          //   this.registData.item['contract_months_internal'] = item['contract_months_calculation'];
          //   this.registData.item['rate_internal'] = item['rate'];
          //   // 社内料率タブの値を与信料率タブにコピー
          //   if (!this.creditEstimateInformationPanel.datas[5].props.value) {
          //     this.creditEstimateInformationPanel.datas[5].props.value = this.estimateInformationPanel.datas[5].props.value;
          //     this.creditEstimateInformationPanel.datas[6].props.value = this.estimateInformationPanel.datas[6].props.value;
          //     this.creditEstimateInformationPanel.datas[7].props.value = this.estimateInformationPanel.datas[7].props.value;
          //     this.creditEstimateInformationPanel.datas[8].props.value = this.estimateInformationPanel.datas[8].props.value;

          //     this.registData.item['leasing_company_id_credit'] = this.registData.item['leasing_company_id_internal'];
          //     this.registData.item['contract_months_credit'] = this.creditEstimateInformationPanel.datas[6].props.value;
          //     this.registData.item['rate_credit'] = this.creditEstimateInformationPanel.datas[7].props.value;
          //     this.registData.item['monthly_lease_fee_credit'] = this.creditEstimateInformationPanel.datas[8].props.value;
          //   }
          //   break;
          // }
          case 'estimate_expiration_date': {
            //見積情報関連の処理は不要なためコメントアウト
            // this.estimateInformationPanel.datas[0].props.value = response.value;
            this.registData.item['estimate_expiration_date'] = response.value;
            break;
          }
          case 'estimate_registration_date': {
            // this.estimateInformationPanel.datas[2].props.value = response.value;
            this.registData.item['estimate_registration_date'] = response.value;
            break;
          }
          case 'estimate_update_date': {
            // this.estimateInformationPanel.datas[3].props.value = response.value;
            this.registData.item['estimate_update_date'] = response.value;
            break;
          }
          default: {
            break;
          }
        }
        break;
      }
      case 'changeSelectTemplete': {
        switch (response.name) {
          case 'materialTemplate': {
            // 構成表テンプレート選択時の処理
            const materialDsId = hexabaseState.datastoreIds['構成表マスタ'];
            let dispMesseage = '';
            const getTempId: string = response.value.value || '';
            const getBody = this.masterData['m_materialtemplate'].body.find(v => v.i_id === getTempId);
            const getIlinks1: any = getBody !== undefined ? getBody['item_links'] : undefined;
            const getIlinks2: [{ d_id: string; item_count: number; items: any }] = getIlinks1 !== undefined ? getIlinks1.links : undefined;
            const getIlinks3: [{ i_id: string; type: string }] =
              getIlinks2 !== undefined ? getIlinks2.find(v => v.d_id === hexabaseState.datastoreIds['構成表テンプレート明細'])?.items : undefined;
            const findListB: Array<PartsListDataFormat> = this.partsListBaseData;

            getIlinks3.forEach(v1 => {
              const getRecode = this.masterData['m_materialtemplate_detail'].body.find(v2 => v2.i_id === v1.i_id);
              const getRecodeFormat: any = getRecode !== undefined ? getRecode : undefined;
              const getRecodewk0: [{ d_id: string; item_count: number; items: [{ i_id: string; type: string }] }] =
                getRecodeFormat !== undefined ? getRecodeFormat.item_links.links : undefined;
              const IndexB1 = getRecodewk0.findIndex(v5 => v5.d_id === materialDsId);
              // ベースデータ ＋ 登録データに対して
              const findIndexB = IndexB1 !== -1 ? findListB.findIndex(v3 => v3.i_id === getRecodewk0[IndexB1].items[0].i_id) : -1;
              const setQuantity: number = getRecodeFormat.quantity !== undefined ? Number(getRecodeFormat.quantity) : 0;

              //数量下限、上限
              const setQuantityLowerLimit: number = getRecodeFormat.quantity_lower_limit !== undefined ? Number(getRecodeFormat.quantity_lower_limit) : 0;
              const setQuantityUpperLimit: number = getRecodeFormat.quantity_upper_limit !== undefined ? Number(getRecodeFormat.quantity_upper_limit) : 0;

              //単価下限、上限
              const setUnitLowerLimit: number = getRecodeFormat.unit_lower_limit !== undefined ? Number(getRecodeFormat.unit_lower_limit) : 0;
              const setUnitUpperLimit: number = getRecodeFormat.unit_upper_limit !== undefined ? Number(getRecodeFormat.unit_upper_limit) : 0;

              // 構成表テンプレート明細のソート順をワークに格納
              const setNo: number =
                getRecodeFormat.sort_no !== undefined ? Number(getRecodeFormat.sort_no) : 0;

              if (findIndexB !== undefined && findIndexB !== -1) {
                // セット ＆ 再計算！！！！
                const itembase: PartsListDataFormat = this.partsListBaseData[findIndexB];
                itembase.quantity = setQuantity;
                itembase.quantity_lower_limit = setQuantityLowerLimit;
                itembase.quantity_upper_limit = setQuantityUpperLimit;
                itembase.unit_lower_limit = setUnitLowerLimit;
                itembase.unit_upper_limit = setUnitUpperLimit;
                itembase.sale_price = itembase.standard_unit_price * itembase.quantity;
                itembase.transfer_amount_price = itembase.transfer_unit_price * itembase.quantity;
                itembase.operating_income = this.calculationModel.operatingIncome(itembase.sale_price, itembase.transfer_amount_price);
                itembase.profit_rate = this.calculationModel.profitRate(
                  this.calculationModel.operatingIncome(itembase.sale_price, itembase.transfer_amount_price),
                  itembase.sale_price,
                  this.defaultRoundingType
                );
                itembase.No = setNo;
                // テンプレートに設定された編集可・不可フラグから行内の入力項目、ボタンを制御
                if (getRecode !== undefined) {
                  itembase.edit_material_flag = getRecode.edit_material_flag === 'true' ? true : false;
                  itembase.buttonDisabled = getRecode.edit_material_flag === 'true' ? false : true;

                  itembase.edit_price_flag = getRecode.edit_price_flag === 'true' ? true : false;
                }
                this.partsListBaseData.splice(findIndexB, 1, itembase);
                // 登録データに追加
                this.$set(this.registMaterialItemData[findIndexB], 'quantity', setQuantity);
                this.$set(this.registMaterialItemData[findIndexB], 'quantity_lower_limit', setQuantityLowerLimit);
                this.$set(this.registMaterialItemData[findIndexB], 'quantity_upper_limit', setQuantityUpperLimit);
                this.$set(this.registMaterialItemData[findIndexB], 'unit_lower_limit', setUnitLowerLimit);
                this.$set(this.registMaterialItemData[findIndexB], 'unit_upper_limit', setUnitUpperLimit);
                this.$set(this.registMaterialItemData[findIndexB], 'edit_material_flag', String(itembase.edit_material_flag));
                this.$set(this.registMaterialItemData[findIndexB], 'edit_price_flag', String(itembase.edit_price_flag));
                this.$set(this.registMaterialItemData[findIndexB], 'display_order', setNo);
              } else {
                // テンプレートが構成とマッチしない、警告を出す！
                dispMesseage = TemplateWarningMessage;
                // マッチしないデータを商品名でマッチングする
                const findIndexB2 = findListB.findIndex(v3 => v3.item === getRecodeFormat.ref_item);
                if (findIndexB2 !== undefined && findIndexB2 !== -1) {
                  // セット ＆ 再計算！！！！
                  const itembase2: PartsListDataFormat = this.partsListBaseData[findIndexB2];
                  itembase2.quantity = setQuantity;
                  itembase2.quantity_lower_limit = setQuantityLowerLimit;
                  itembase2.quantity_upper_limit = setQuantityUpperLimit;
                  itembase2.unit_lower_limit = setUnitLowerLimit;
                  itembase2.unit_upper_limit = setUnitUpperLimit;
                  itembase2.sale_price = itembase2.standard_unit_price * itembase2.quantity;
                  itembase2.transfer_amount_price = itembase2.transfer_unit_price * itembase2.quantity;
                  itembase2.operating_income = this.calculationModel.operatingIncome(itembase2.sale_price, itembase2.transfer_amount_price);
                  itembase2.profit_rate = this.calculationModel.profitRate(
                    this.calculationModel.operatingIncome(itembase2.sale_price, itembase2.transfer_amount_price),
                    itembase2.sale_price,
                    this.defaultRoundingType
                  );
                  itembase2.No = setNo;
                  // 編集可にする
                  itembase2.edit_material_flag = true;
                  itembase2.buttonDisabled = false;

                  itembase2.edit_price_flag = true;

                  this.partsListBaseData.splice(findIndexB2, 1, itembase2);
                  // 登録データに追加
                  this.$set(this.registMaterialItemData[findIndexB2], 'quantity', setQuantity);
                  this.$set(this.registMaterialItemData[findIndexB2], 'quantity_lower_limit', setQuantityLowerLimit);
                  this.$set(this.registMaterialItemData[findIndexB2], 'quantity_upper_limit', setQuantityUpperLimit);
                  this.$set(this.registMaterialItemData[findIndexB2], 'unit_lower_limit', setUnitLowerLimit);
                  this.$set(this.registMaterialItemData[findIndexB2], 'unit_upper_limit', setUnitUpperLimit);
                  this.$set(this.registMaterialItemData[findIndexB2], 'edit_material_flag', String(false));
                  this.$set(this.registMaterialItemData[findIndexB2], 'edit_price_flag', String(false));
                  this.$set(this.registMaterialItemData[findIndexB2], 'display_order', setNo);
                }
              }
            });

            // 警告メッセージの表示
            if (dispMesseage.length > 0) {
              this.$set(this.estimateTabData[0].configurationTableData.vmSelectDataTemplete, 'displayInfomation', dispMesseage);
            }

            // partsListBaseDataをNoの昇順で並べ替え（構成表テンプレート明細のソート順で並べ替え）
            this.partsListBaseData.sort((a: { No: number }, b: { No: number }) => a.No - b.No);
            // 登録データもdisplay_orderの昇順で並べ替え（構成表テンプレート明細のソート順で並べ替え）
            this.registMaterialItemData.sort(
              (a: { display_order: number }, b: { display_order: number }) =>
                a.display_order - b.display_order
            );

            // リストデータを表示として再セット
            if (this.checkBoxsStatus === true) {
              this.partsListViewData = this.filterDataItem(JSON.parse(JSON.stringify(this.partsListBaseData)), 'quantity', 0, false);
              for (const index in this.partsListViewData) {
                this.partsListViewData[index]['No'] = Number(index) + 1;
              }
            } else {
              this.partsListViewData = JSON.parse(JSON.stringify(this.partsListBaseData));
            }
            this.$set(this.estimateTabData[0].configurationTableData.partsList.tableParameters, 'body', this.partsListViewData);
            break;
          }
        }
        break;
      }
    }

    //見積情報関連の処理は不要なためコメントアウト
    // ■上の段
    // ①定価金額（構成表）
    // this.estimateInformationSummary.datas[0].props.value = this.estimateInformationSummaryTotalValues(
    //   'noEstimateDetailList',
    //   'sale_price'
    // );
    // this.registData.item[
    //   'composition_table_list_price_total'
    // ] = this.estimateInformationSummary.datas[0].props.value;
    // // ③値引額
    // this.estimateInformationSummary.datas[2].props.value = this.calculationModel.totalValues([
    //   {
    //     tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList
    //       .tableParameters.body,
    //     itemName: 'sale_price',
    //     sumItem: {
    //       display_id: 'type_id',
    //       targetName: '値引'
    //     }
    //   }
    // ]);
    // // ②小計(構成表＋見積明細)※元の見積合計金額
    // this.estimateInformationSummary.datas[1].props.value =
    //   this.estimateInformationSummaryTotalValues('', 'sale_price') -
    //   this.estimateInformationSummary.datas[2].props.value;
    // this.registData.item[
    //   'total_sales_amount'
    // ] = this.estimateInformationSummary.datas[1].props.value;
    // this.registData.item['discount_amount'] = this.estimateInformationSummary.datas[2].props.value;
    // // ④見積合計金額(税別)
    // this.estimateInformationSummary.datas[3].props.value =
    //   this.estimateInformationSummary.datas[1].props.value -
    //   this.estimateInformationSummary.datas[2].props.value;
    // this.registData.item[
    //   'estimated_tax_excluded'
    // ] = this.estimateInformationSummary.datas[3].props.value;
    // // ■下の段
    // // ⑤消費税率、⑥消費税額、⑦合計金額(税込)
    // this.estimateInformationSummaryTaxAmount();
    // this.registData.item['sales_tax_rate'] = Number(
    //   this.estimateInformationSummary.datas[4].props.value
    // );
    // this.registData.item['consumption_tax'] = this.estimateInformationSummary.datas[5].props.value;
    // this.registData.item[
    //   'total_tax_included'
    // ] = this.estimateInformationSummary.datas[6].props.value;
    // // ⑧営業利益合計
    // // 営業利益合計(例外リストに存在し、項目が表示されてる場合は計算する)
    // if (this.exceptionHeaderItem.includes('transfer_amount_price')) {
    //   this.estimateInformationSummary.datas[7].props.value = this.estimateInformationSummaryTotalValues(
    //     '',
    //     'operating_income'
    //   );
    //   this.registData.item[
    //     'total_operating_profit'
    //   ] = this.estimateInformationSummary.datas[7].props.value;
    // }
    // // ⑨営業利益率
    // // 営業利益率(例外リストに存在し、項目が表示されてる場合は計算する)
    // if (this.exceptionHeaderItem.includes('profit_rate')) {
    //   this.estimateInformationSummary.datas[8].props.value = this.operatingProfitMargin();
    //   const strIndex = this.estimateInformationSummary.datas[8].props.value.indexOf('%');
    //   const str = this.estimateInformationSummary.datas[8].props.value.substring(0, strIndex);
    //   this.registData.item['operating_profit_margin'] = Number(str);
    // }
    // // 月額リース料の計算
    // switch (this.screenStructureType) {
    //   case '1': {
    //     // OAリース
    //     if (this.estimateInformationSummary.datas[6].props.value !== 0) {
    //       const rateItem = this.mastermEstimateRateData.find(
    //         (recode: any) => recode.i_id === this.estimateInformationPanel.datas[5].props.value
    //       );
    //       if (rateItem !== undefined) {
    //         const cost = this.calculationModel.monthlyLeaseCost(
    //           this.estimateInformationSummary.datas[6].props.value,
    //           Number(rateItem['rate'])
    //         );
    //         this.estimateInformationPanel.datas[8].props.value = cost;
    //         this.creditEstimateInformationPanel.datas[8].props.value = cost;
    //         this.fractionValue = this.calculationModel.fractionProcess(cost);
    //       }
    //       this.registData.item['monthly_lease_fee_internal'] = Number(
    //         this.estimateInformationPanel.datas[8].props.value
    //       );
    //       this.registData.item['monthly_lease_fee_credit'] = Number(
    //         this.creditEstimateInformationPanel.datas[8].props.value
    //       );
    //       break;
    //     }
    //   }
    // }
  }

  //見積情報関連の処理は不要なためコメントアウト
  // private estimateInformationSummaryTotalValues(testFlag: string, str: string) {
  //   const totalBaseData = [];
  //   const partsList = {
  //     tableData: this.estimateTabData[0].configurationTableData.partsList.tableParameters.body,
  //     itemName: str
  //   };

  //   const detailAddList = {
  //     tableData: this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body,
  //     itemName: str
  //   };

  //   const estimateDetailList = {
  //     tableData: this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters
  //       .body,
  //     itemName: str
  //   };

  //   totalBaseData.push(partsList);
  //   totalBaseData.push(detailAddList);
  //   if (testFlag !== 'noEstimateDetailList') {
  //     totalBaseData.push(estimateDetailList);
  //   }
  //   const total = this.calculationModel.totalValues(totalBaseData);
  //   return total;
  // }

  // private estimateInformationSummaryTaxAmount() {
  //   this.estimateInformationSummary.datas[5].props.value = this.calculationModel.taxAmount(
  //     this.estimateInformationSummary.datas[4].props.value,
  //     this.estimateInformationSummary.datas[3].props.value,
  //     'taxOnly',
  //     { calculationType: 'floor' }
  //   );
  //   this.estimateInformationSummary.datas[6].props.value = this.calculationModel.taxAmount(
  //     this.estimateInformationSummary.datas[4].props.value,
  //     this.estimateInformationSummary.datas[3].props.value,
  //     'taxIncluded',
  //     { calculationType: 'floor' }
  //   );
  // }

  // private operatingProfitMargin() {
  //   let sum = 0;
  //   let marginCount = 0;
  //   const baseArray = [
  //     this.estimateTabData[0].configurationTableData.partsList.tableParameters.body,
  //     this.estimateTabData[0].configurationTableData.detailAddList.tableParameters.body,
  //     this.estimateTabData[1].estimateInformationData.estimateDetailList.tableParameters.body
  //   ];

  //   for (const indexA in baseArray) {
  //     for (const indexB in baseArray[indexA]) {
  //       const strIndex = baseArray[indexA][indexB]['profit_rate'].indexOf('%');
  //       const str = baseArray[indexA][indexB]['profit_rate'].substring(0, strIndex);
  //       if (baseArray[indexA][indexB]['profit_rate'] !== undefined && Number(str) !== 0) {
  //         sum += Number(str);
  //         marginCount++;
  //       }
  //     }
  //   }

  //   sum = sum / marginCount;
  //   if (isNaN(sum) || isFinite(sum) === false || '-Infinity' === String(sum)) {
  //     sum = 0;
  //   }
  //   sum = this.calculationModel.roundingProcess(sum, { calculationType: 'decimalRound', digit: 1 });
  //   return String(sum) + '%';
  // }

  private async clearExecDialog(response: any) {
    if (response !== undefined && response.isAgree) {
      // 端数有で登録の確認ができたので登録を行う
      this.fractionValue = 0;
      this.execAction(this.execActionType);
    }
    this.isExecDialog = false;
  }

  private dataFindItem(
    findData: any,
    findDataString: string,
    findConditionsItem: string | number,
    isEquivalent = true
  ) {
    const item = findData.find((item: any) => {
      if (isEquivalent === true) {
        if (item[findDataString] === findConditionsItem) {
          return item;
        }
      } else {
        if (item[findDataString] !== findConditionsItem) {
          return item;
        }
      }
    });
    return item;
  }

  private dataFindIndex(
    findData: any,
    findDataString: string,
    findConditionsItem: string | number,
    isEquivalent = true
  ) {
    const index = findData.findIndex((item: any) => {
      if (isEquivalent === true) {
        if (item[findDataString] === findConditionsItem) {
          return item;
        }
      } else {
        if (item[findDataString] !== findConditionsItem) {
          return item;
        }
      }
    });
    return index;
  }

  private filterDataItem(
    filterData: any,
    filterDataString: string,
    filterConditionsItem: string | number,
    isEquivalent = true
  ) {
    const item = filterData.filter((item: any) => {
      if (isEquivalent === true) {
        if (item[filterDataString] === filterConditionsItem) {
          return item;
        }
      } else {
        if (item[filterDataString] !== filterConditionsItem) {
          return item;
        }
      }
    });
    return item;
  }

  private createGroupByTaxClassificationId(listData: Array<any>) {
    const group = listData.reduce(function(result: any, current: any) {
      const element = result.find(function(p: { tax_classification_id: string }) {
        return p.tax_classification_id === current.tax_classification_id;
      });
      if (element) {
        element.amount +=
          Number(
            current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
          ) * Number(current.quantity);
      } else {
        if (current.tax_classification && Number(current.quantity) !== 0) {
          result.push({
            name: current.tax_classification,
            tax_classification_id: current.tax_classification_id,
            tax_rate: current.tax_rate ? current.tax_rate : 0,
            amount:
              Number(
                current.unit_price !== undefined ? current.unit_price : current.standard_unit_price
              ) * Number(current.quantity)
          });
        }
      }
      return result;
    }, []);
    for (const key in group) {
      // 小数点以下の消費税は切り捨て
      group[key].tax = Math.floor(
        (Number(group[key].amount) * Number(group[key].tax_rate ? group[key].tax_rate : 0)) / 100
      );
      group[key].tax_included_amount = Number(group[key].amount) + Number(group[key].tax);
    }
    return group;
  }

  /**
   * アラートダイアログボタンクリック時処理
   * @param {any} response 押下ボタン情報
   */
  private async clickAlertDialog(response: any) {
    if (response !== undefined && response.isAgree) {
      this.isAlertDialog = false;
    }
  }
}
